import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ContentCard from "@/components/ContentCard";

export default function CategoryRow({ title, subtitle, items }) {
  const scrollRef = useRef(null);
  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 600, behavior: "smooth" });
  };

  if (!items || !items.length) return null;

  return (
    <section className="relative" data-testid={`category-row-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-end justify-between mb-4 px-1">
        <div>
          {subtitle && <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-1">{subtitle}</p>}
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-white leading-none">{title}</h3>
        </div>
        <div className="hidden md:flex items-center gap-2">
          <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full btn-ghost flex items-center justify-center" data-testid={`row-prev-${title.toLowerCase().replace(/\s+/g, "-")}`}>
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full btn-ghost flex items-center justify-center" data-testid={`row-next-${title.toLowerCase().replace(/\s+/g, "-")}`}>
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div ref={scrollRef} className="row-scroll flex gap-4 overflow-x-auto pb-2 -mx-1 px-1">
        {items.map((it) => <ContentCard key={it.id} item={it} />)}
      </div>
    </section>
  );
}
